import React from "react";
//#region types
import { BlurBackdropProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
//#endregion
import cssExports from "theme/styles/main.module.scss";

const BlurBackdrop: React.FC<BlurBackdropProps> = (props) => {
  const { show, onClick } = props;
  return show ? <div className={cssExports.backdrop} onClick={onClick}></div> : <></>;
};

export default BlurBackdrop;
